// DrainPro Advanced PP SWR System Catalog - PIPES ONLY
// HSN CODE: 39172390

export const drainproCatalog = {
    page: 1,
    title: "ASTRAL DRAINPRO - THE ADVANCED PP SWR SYSTEM",
    hsn_code: "39172390",
    description: "Advanced PP SWR pipes made with German technology - ICON Approved",
    features: [
        "Made with German Technology",
        "ICON Approved",
        "13DB Q'zips Technology",
        "Advanced PP SWR System",
        "Superior drainage performance"
    ],
    sections: [
        {
            name: "PIPES - 3M QS",
            length: "3M QS",
            items: [
                { size_mm: "40", length_socket: "3M QS", product_code: "M48270304", std_pkg: 1, price_inr_per_pc: 441.00 },
                { size_mm: "40", length_socket: "2M D/S", product_code: "M48280204", std_pkg: 1, price_inr_per_pc: 494.00 },
                { size_mm: "40", length_socket: "1 RFT S/S", product_code: "M48271014", std_pkg: 1, price_inr_per_pc: 135.00 },
                { size_mm: "40", length_socket: "2 RFT D/S", product_code: "M48282024", std_pkg: 1, price_inr_per_pc: 201.00 },
                { size_mm: "40", length_socket: "3 RFT D/S", product_code: "M48283304", std_pkg: 1, price_inr_per_pc: 717.00 },
                { size_mm: "40", length_socket: "4 RFT S/S", product_code: "M48274404", std_pkg: 1, price_inr_per_pc: 295.00 },
                { size_mm: "40", length_socket: "6 RFT S/S", product_code: "M48276604", std_pkg: 1, price_inr_per_pc: 344.00 },
                { size_mm: "50", length_socket: "3M D/S", product_code: "M48280304", std_pkg: 1, price_inr_per_pc: 371.00 },
                { size_mm: "50", length_socket: "3M QS", product_code: "M48270305", std_pkg: 1, price_inr_per_pc: 557.00 },
                { size_mm: "50", length_socket: "3M QIS", product_code: "M48080105", std_pkg: 1, price_inr_per_pc: 579.00 },
                { size_mm: "50", length_socket: "1 RFT S/S", product_code: "M48271105", std_pkg: 1, price_inr_per_pc: 69.00 },
                { size_mm: "50", length_socket: "2 RFT D/S", product_code: "M48282025", std_pkg: 1, price_inr_per_pc: 176.00 },
                { size_mm: "50", length_socket: "3 RFT D/S", product_code: "M48283305", std_pkg: 1, price_inr_per_pc: 246.00 },
                { size_mm: "50", length_socket: "4 RFT D/S", product_code: "M48284405", std_pkg: 1, price_inr_per_pc: 310.00 },
                { size_mm: "50", length_socket: "4 RFT S/S", product_code: "M48274405", std_pkg: 1, price_inr_per_pc: 414.00 },
                { size_mm: "50", length_socket: "6 RFT D/S", product_code: "M48286605", std_pkg: 1, price_inr_per_pc: 439.00 },
                { size_mm: "75", length_socket: "3M QS", product_code: "M48270307", std_pkg: 1, price_inr_per_pc: 1367.00 },
                { size_mm: "75", length_socket: "3M QIS", product_code: "M48080107", std_pkg: 1, price_inr_per_pc: 1423.00 },
                { size_mm: "75", length_socket: "1 RFT S/S", product_code: "M48271107", std_pkg: 1, price_inr_per_pc: 170.00 },
                { size_mm: "75", length_socket: "2 RFT D/S", product_code: "M48282027", std_pkg: 1, price_inr_per_pc: 393.00 },
                { size_mm: "75", length_socket: "3 RFT D/S", product_code: "M48283307", std_pkg: 1, price_inr_per_pc: 549.00 },
                { size_mm: "75", length_socket: "4 RFT D/S", product_code: "M48284407", std_pkg: 1, price_inr_per_pc: 724.00 },
                { size_mm: "75", length_socket: "5 RFT S/S", product_code: "M48275607", std_pkg: 1, price_inr_per_pc: 1077.00 },
                { size_mm: "75", length_socket: "6 RFT D/S", product_code: "M48286607", std_pkg: 1, price_inr_per_pc: 1028.00 },
                { size_mm: "90", length_socket: "3M QS", product_code: "M48270308", std_pkg: 1, price_inr_per_pc: 1765.00 },
                { size_mm: "90", length_socket: "3M QIS", product_code: "M48080308", std_pkg: 1, price_inr_per_pc: 1744.00 },
                { size_mm: "90", length_socket: "2 RFT D/S", product_code: "M48282008", std_pkg: 1, price_inr_per_pc: 255.00 },
                { size_mm: "90", length_socket: "2 RFT D/S", product_code: "M48282008", std_pkg: 1, price_inr_per_pc: 458.00 },
                { size_mm: "90", length_socket: "3 RFT D/S", product_code: "M48283308", std_pkg: 1, price_inr_per_pc: 641.00 },
                { size_mm: "90", length_socket: "4RFT D/S", product_code: "M48284408", std_pkg: 1, price_inr_per_pc: 819.00 },
                { size_mm: "90", length_socket: "6 RFT S/S", product_code: "M48276608", std_pkg: 1, price_inr_per_pc: 1186.00 },
                { size_mm: "90", length_socket: "6RFT DF", product_code: "M48286608", std_pkg: 1, price_inr_per_pc: 1201.00 },
                { size_mm: "110", length_socket: "3M QS", product_code: "M48270309", std_pkg: 1, price_inr_per_pc: 2203.00 },
                { size_mm: "110", length_socket: "3M QIS", product_code: "M48080309", std_pkg: 1, price_inr_per_pc: 2111.00 },
                { size_mm: "110", length_socket: "1 RFT D/S", product_code: "M48271109", std_pkg: 1, price_inr_per_pc: 241.00 },
                { size_mm: "110", length_socket: "2 RFT D/S", product_code: "M48282029", std_pkg: 1, price_inr_per_pc: 598.00 },
                { size_mm: "110", length_socket: "3 RFT D/S", product_code: "M48283309", std_pkg: 1, price_inr_per_pc: 783.00 },
                { size_mm: "110", length_socket: "4 RFT D/S", product_code: "M48284409", std_pkg: 1, price_inr_per_pc: 1028.00 },
                { size_mm: "110", length_socket: "6 RFT S/S", product_code: "M48276609", std_pkg: 1, price_inr_per_pc: 1443.00 },
                { size_mm: "110", length_socket: "6 RFT D/S", product_code: "M48286609", std_pkg: 1, price_inr_per_pc: 1534.00 },
                { size_mm: "160", length_socket: "3M QS", product_code: "M48270312", std_pkg: 1, price_inr_per_pc: 3707.00 },
                { size_mm: "160", length_socket: "3M QIS", product_code: "M48127112", std_pkg: 1, price_inr_per_pc: 4219.00 },
                { size_mm: "160", length_socket: "1 RFT S/S", product_code: "M48271112", std_pkg: 1, price_inr_per_pc: 427.00 }
            ]
        },
        {
            name: "PIPES - Additional Sizes",
            length: "Various",
            items: [
                { size_mm: "160", length_socket: "2 RFT D/S", product_code: "M48182212", std_pkg: 1, price_inr_per_pc: 1089.00 },
                { size_mm: "160", length_socket: "3 RFT D/S", product_code: "M48182442", std_pkg: 1, price_inr_per_pc: 1501.00 },
                { size_mm: "160", length_socket: "4 RFT D/S", product_code: "M48182442", std_pkg: 1, price_inr_per_pc: 1851.00 },
                { size_mm: "160", length_socket: "6 RFT S/S", product_code: "M48182612", std_pkg: 1, price_inr_per_pc: 2641.00 },
                { size_mm: "200", length_socket: "3M QS", product_code: "M48170314", std_pkg: 1, price_inr_per_pc: 2411.00 },
                { size_mm: "200", length_socket: "3M QIS", product_code: "M48172314", std_pkg: 1, price_inr_per_pc: 6445.00 },
                { size_mm: "200", length_socket: "3M QS", product_code: "M48270314", std_pkg: 1, price_inr_per_pc: 7057.00 },
                { size_mm: "200", length_socket: "1 RFT S/S", product_code: "M48271114", std_pkg: 1, price_inr_per_pc: 613.00 },
                { size_mm: "200", length_socket: "3 RFT D/S", product_code: "M48283214", std_pkg: 1, price_inr_per_pc: 3100.00 },
                { size_mm: "200", length_socket: "3 RFT D/S", product_code: "M48182334", std_pkg: 1, price_inr_per_pc: 3324.00 },
                { size_mm: "200", length_socket: "4 RFT S/S", product_code: "M48170614", std_pkg: 1, price_inr_per_pc: 4925.00 },
                { size_mm: "200", length_socket: "6 RFT S/S", product_code: "M48182616", std_pkg: 1, price_inr_per_pc: 10487.00 },
                { size_mm: "250", length_socket: "3M QS", product_code: "M48270316", std_pkg: 1, price_inr_per_pc: 1630.00 },
                { size_mm: "250", length_socket: "1 RFT S/S", product_code: "M48271116", std_pkg: 1, price_inr_per_pc: 1630.00 },
                { size_mm: "250", length_socket: "6 RFT D/S", product_code: "M48182616", std_pkg: 1, price_inr_per_pc: 3949.00 }
            ]
        }
    ]
};

// Helper function to format price in INR
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

// Helper function to get all DrainPro products as flat array
export const getAllDrainProProducts = () => {
    const allProducts = [];
    drainproCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `drainpro-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                hsnCode: drainproCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

// Get unique sizes for filter
export const getDrainProSizes = () => {
    const allProducts = getAllDrainProProducts();
    return [...new Set(allProducts.map(p => p.size_mm))].sort((a, b) => parseInt(a) - parseInt(b));
};

// Get unique socket types for filter
export const getDrainProSocketTypes = () => {
    const allProducts = getAllDrainProProducts();
    return [...new Set(allProducts.map(p => p.length_socket))];
};
